module.exports = __webpack_public_path__ + "img/1-1.97f545c0.png";